import { useState, useRef, useCallback } from 'react';
import { debounce } from 'lodash';
import { configureMonaco } from '../schema/workflow';
import { EDITOR_DEBOUNCE_DELAY } from '../data/constants/workflowDefConstants';
import { parseJson } from '../utils/workflowDefinition/workflowDefinitionUtils';
export function useWorkflowEditor() {
    // Editor-related state
    const [isEditorMounted, setIsEditorMounted] = useState(false);
    const [decorations, setDecorations] = useState([]);
    const [hasEditorLoaded, setHasEditorLoaded] = useState(false);
    const [jsonErrors, setJsonErrors] = useState([]);
    const [jsonParseError, setJsonParseError] = useState(false);
    const [isCodeModified, setIsCodeModified] = useState(false);
    const [newWorkflow, setNewWorkflow] = useState(null);

    // Editor refs
    const editorRef = useRef();
    const debouncedHandleChange = useRef(null);

    // Monaco Handlers
    const handleEditorWillMount = (monaco) => {
        configureMonaco(monaco);
    };

    const handleEditorDidMount = (editor) => {
        editorRef.current = editor;
        setHasEditorLoaded(editor ? true : false);
    };

    const handleValidate = (markers) => {
        setJsonErrors(markers);
        setIsEditorMounted(true);
    };

    const handleJsonErrors = (errors) => {
        setJsonErrors(errors);
    };

    const handleEditorChange = useCallback((value, workflowJson, setIsModified, setTasks) => {
        if (value === "") {
            handleChange(value, workflowJson, setIsModified, setTasks);
            return;
        }

        if (debouncedHandleChange.current) {
            debouncedHandleChange.current.cancel();
        }

        debouncedHandleChange.current = debounce((value) => {
            handleChange(value, workflowJson, setIsModified, setTasks);
        }, EDITOR_DEBOUNCE_DELAY);

        debouncedHandleChange.current(value);
    }, []);

    const handleChange = (v, workflowJson, setIsModified, setTasks) => {
        setIsModified(v !== workflowJson);
        setIsCodeModified(v !== workflowJson);

        const result = parseJson(v)
        if (result.data !== null && result.success) {
            setNewWorkflow(v);
            setTasks(result?.data?.tasks || []);
            setJsonParseError(false);
        }
        else {
            setJsonParseError(true);
            console.error(result.error)
        }
        // try {
        //     let parsedNewWorkflow = JSON.parse(v);
        //     if (parsedNewWorkflow) {
        //         setNewWorkflow(v);
        //         setTasks(parsedNewWorkflow.tasks);
        //         setJsonParseError(false);
        //     }
        // } catch (e) {
        //     setJsonParseError(true);
        //     return console.error(e);
        // }
    };

    return {
        // State
        isEditorMounted,
        decorations,
        hasEditorLoaded,
        jsonErrors,
        jsonParseError,
        isCodeModified,
        newWorkflow,

        // Refs
        editorRef,
        debouncedHandleChange,

        // Handlers
        handleEditorWillMount,
        handleEditorDidMount,
        handleValidate,
        handleJsonErrors,
        handleEditorChange,

        // Setters (for external use)
        setDecorations,
        setIsCodeModified,
        setNewWorkflow,
        setJsonErrors,
        setJsonParseError
    };
}
